// extracted by mini-css-extract-plugin
export var container = "_8p-0";